import React from 'react';
import { ReactComponent as LoadingSpinnerWhite } from './icons/loading-spinner-white.svg';

export default () => <LoadingSpinnerWhite />;
